module.exports = __webpack_public_path__ + "img/bx-calendar.697a1ada.svg";